import Button from '@rategravity/frontend/components/button';
import React from 'react';

export default ({ completeText, disabled, onSubmit }) => (
  <Button disabled={disabled} onClick={onSubmit}>
    <div style={{ padding: '.5em 0' }}>{completeText}</div>
  </Button>
);



// WEBPACK FOOTER //
// ./src/components/card/complete-button.js